import Modal from 'react-responsive-modal'

import {classNames} from '_metronic/helpers'

interface UpdateSetupProps {
  open: boolean
  className?: string
  onClose: () => void
  children: React.ReactNode
  title: string
}

export function UpdateSetup({open, onClose, className, children, title}: UpdateSetupProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      styles={{
        overlay: {background: 'rgba(0,0,0,0.55)'},
        modal: {
          background: 'var(--card-bg)',
          border: '1px solid var(--card-border)',
          borderRadius: '16px',
          padding: '0',
          margin: '0',
          minWidth: 'min(420px, calc(100vw - 32px))',
          maxWidth: '540px',
          width: 'min(540px, calc(100vw - 32px))',
          maxHeight: 'calc(100dvh - 32px)',
          overflow: 'hidden',
          boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
        },
      }}
      showCloseIcon={false}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px 20px',
          borderBottom: '1px solid var(--divider)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h2
          style={{
            margin: 0,
            color: 'var(--text-primary)',
            fontSize: '16px',
            fontWeight: 600,
            textTransform: 'capitalize',
          }}
        >
          {title}
        </h2>
        <button
          type='button'
          onClick={onClose}
          style={{
            background: 'var(--elevated-bg)',
            border: 'none',
            borderRadius: '8px',
            color: 'var(--text-muted)',
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          ✕
        </button>
      </div>

      <div
        className={classNames('p-5', className)}
        style={{maxHeight: 'calc(100dvh - 96px)', overflowY: 'auto'}}
      >
        {children}
      </div>
    </Modal>
  )
}
